import React, { useRef, useState } from "react";
import { Modal, Form, Input, message } from "antd";
import { addPharmacyConfigApi } from "../../../services/pharmacyConfigs.services";
import { nameRules, shortCodeRules } from "../common/validators";

const CategoryFormModal = ({ open, setOpen, onCreated }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const closeAndReset = () => {
    form.resetFields();
    setOpen(false);
  };

  const onFinish = (values) => {
    setLoading(true);
    addPharmacyConfigApi("categories", values)
      .then((res) => {
        message.success("Category added successfully");
        setLoading(false);
        closeAndReset();
        onCreated?.(res.data);
      })
      .catch((err) => {
        message.error(err?.response?.data?.message || "Failed to save category");
        setLoading(false);
      });
  };

  return (
    <Modal
      title="Add Category"
      open={open}
      onCancel={closeAndReset}
      centered
      width={420}
      destroyOnClose
      okText="Save"
      confirmLoading={loading}
      onOk={() => formRef.current?.submit()}
    >
      <Form layout="vertical" form={form} ref={formRef} onFinish={onFinish}>
        <Form.Item
          label="Name"
          name="name"
          rules={nameRules("Category")}
        >
          <Input placeholder="Category Name" />
        </Form.Item>
        <Form.Item label="Short Code" name="short_code" rules={shortCodeRules}>
          <Input placeholder="Short Code" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CategoryFormModal;
